// src/firebase/firebase.utils.js
import { initializeApp } from 'firebase/app';
import { 
  getFirestore, 
  collection, 
  doc, 
  getDoc, 
  setDoc, 
  writeBatch,
  getDocs,
  query,
  where,
  onSnapshot,
  addDoc,
  deleteDoc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  orderBy
} from 'firebase/firestore';
import {
  getAuth,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserLocalPersistence
} from 'firebase/auth';

// ===== YOUR FIREBASE CONFIG =====
const firebaseConfig = {
  apiKey: "AIzaSyBGm1matOkKygEgdpMl40atkA1YrXRhsL8",
  authDomain: "crispyhairsolution.firebaseapp.com",
  projectId: "crispyhairsolution",
  storageBucket: "crispyhairsolution.firebasestorage.app",
  messagingSenderId: "929357725984",
  appId: "1:929357725984:web:72784c1dc4ef8a6d5fd745",
  measurementId: "G-3ZZSEGM415"
};

// ===== INITIALIZE FIREBASE =====
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const firestore = getFirestore(app);

// ===== SET PERSISTENCE =====
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log('✅ Firebase persistence set successfully');
  })
  .catch((error) => {
    console.error('❌ Firebase persistence error:', error);
  });

// ===== GOOGLE AUTH PROVIDER =====
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });

// ============================================
// ===== USER FUNCTIONS =====
// ============================================

// ===== CREATE USER PROFILE DOCUMENT =====
export const createUserProfileDocument = async (userAuth, additionalData) => {
  if (!userAuth) return;

  const userRef = doc(firestore, `users/${userAuth.uid}`);
  const snapShot = await getDoc(userRef);

  if (!snapShot.exists()) {
    const { displayName, email, photoURL } = userAuth;
    const createdAt = new Date();

    try {
      await setDoc(userRef, {
        displayName,
        email,
        photoURL,
        createdAt,
        ...additionalData
      });
    } catch (error) {
      console.log('Error creating user', error.message);
    }
  }

  return userRef;
};

// ===== ADD COLLECTION AND DOCUMENTS =====
export const addCollectionAndDocuments = async (collectionKey, objectsToAdd) => {
  const collectionRef = collection(firestore, collectionKey);
  const batch = writeBatch(firestore);

  objectsToAdd.forEach(obj => {
    const newDocRef = doc(collectionRef);
    batch.set(newDocRef, obj);
  });

  return await batch.commit();
};

// ===== CONVERT COLLECTION SNAPSHOT TO MAP =====
export const convertCollectionsSnapshotToMap = (collections) => {
  const transformedCollection = collections.docs.map(doc => {
    const { title, items } = doc.data();

    return {
      routeName: encodeURI(title.toLowerCase()),
      id: doc.id,
      title,
      items
    };
  });

  return transformedCollection.reduce((accumulator, collection) => {
    accumulator[collection.title.toLowerCase()] = collection;
    return accumulator;
  }, {});
};

// ===== GET CURRENT USER =====
export const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, userAuth => {
      unsubscribe();
      resolve(userAuth);
    }, reject);
  });
};

// ===== SIGN IN WITH GOOGLE =====
export const signInWithGoogle = () => {
  return signInWithPopup(auth, googleProvider);
};

// ============================================
// ===== EXPORTS =====
// ============================================

export {
  auth,
  firestore,           // ✅ Firestore exported
  googleProvider,
  app,
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  signInWithPopup,
  getDoc,
  setDoc,
  collection,
  doc,
  writeBatch,
  getDocs,
  query,
  where,
  onSnapshot,
  addDoc,
  deleteDoc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  orderBy
};

export default app;